import { useEffect, useState } from 'react'
import { getScrollLimitY } from '../helpers'

export function useBlueHeader(isOpen) {
    const [isScrolled, setIsScrolled] = useState(false)

    const isBlue = isScrolled || isOpen

    useEffect(() => {
        const limitScrollY = getScrollLimitY()

        function handleScroll() {
            if (window.scrollY > limitScrollY) {
                setIsScrolled(true)
            } else {
                setIsScrolled(false)
            }
        }

        window.addEventListener('scroll', handleScroll)

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return { isBlue }
}
